import { useCallback } from "react";
import { useFilter } from "react-aria";

/**
 * locale-aware, case- and diacritic-insensitive text matching for filtering
 * lists: `items.filter((u) => matches(query, u.name, u.email))`.
 * an empty or whitespace-only query matches everything.
 */
export function useTextFilter() {
  const { contains } = useFilter({ sensitivity: "base" });
  return useCallback(
    (query: string, ...fields: Array<string | null | undefined>) => {
      const trimmed = query.trim();
      if (!trimmed) return true;
      return fields.some((field) => !!field && contains(field, trimmed));
    },
    [contains],
  );
}
